import { createAction, props } from '@ngrx/store';
import {DashboardItem} from "../../../landingpage/dashboard.model";

export const loadCacheStart = createAction('ZEIT::LOAD_CACHE_START');
export const loadCacheSucceeded = createAction('ZEIT::LOAD_CACHE_SUCCEEDED', props<{ item: DashboardItem[] }>());
export const loadCacheFailed = createAction('ZEIT::LOAD_CACHE_FAILED', props<{ error: Error }>());
